/**
 * Program Builder Validation Schemas
 * Feature: 028-we-want-to - Program Builder Admin Page
 */

import { z } from "zod";

/**
 * Validation schema for program details form
 * Used in Stage 1 (create) and Details tab (edit)
 */
export const programDetailsFormSchema = z.object({
  name: z
    .string()
    .min(1, "Program name is required")
    .max(255, "Program name must be 255 characters or less"),
  description: z.string().min(1, "Description is required"),
  tagline: z
    .string()
    .max(500, "Tagline must be 500 characters or less")
    .optional()
    .or(z.literal("")),
  thumbnailUrl: z
    .string()
    .url("Must be a valid URL")
    .optional()
    .or(z.literal("")),
  price: z.number().min(0, "Price cannot be negative").nullable(),
  isPublished: z.boolean().default(false),
});

/**
 * Inferred type from schema for type-safe form handling
 */
export type ProgramDetailsFormSchemaValues = z.infer<
  typeof programDetailsFormSchema
>;

/**
 * Default form values for new program creation
 */
export const programDetailsFormDefaults: ProgramDetailsFormSchemaValues = {
  name: "",
  description: "",
  tagline: "",
  thumbnailUrl: "",
  price: null,
  isPublished: false,
};
